export default {
  lang: {
    reset: 'Zurücksetzen',
    search: 'Screening',
    expand: 'Erweitern',
    collapse: 'Weglegen',
  },
};
